<template>
  <span v-if="$permissionCheck(`${permissionName}_store`)" :class="$vuetify.display.mdAndDown ? 'mb-2 d-block' : 'mr-2'">

    <!-- WHEN ADD BUTTON IS DISABLED WITH A TOOLTIP -->
    <template v-if="disabledTooltip">
      <v-tooltip :text="disabledTooltip">
        <template #activator="{ props }">
          <v-btn
            v-bind="props"
            variant="tonal"
          ><v-icon
            icon="mdi-plus"
            class="pr-2"
          />{{ $translate(`${translationName}.add`) }}</v-btn>
        </template>
      </v-tooltip>
    </template>

    <!-- WHEN MODAL IS OPENED ON CLICK WITH CUSTOM EVENT ON VALIDATE FROM PARENT -->
    <template v-else-if="setupDialog">
      <v-dialog
        v-model="dialog"
        :width="width || '550'"
        persistent
        @update:model-value="$emit('isOpen', $event)"
      >
        <template #activator="{ props }">
          <v-btn
            v-bind="props"
            id="menu-add-options"
            color="primary"
          >
            <v-icon
              icon="mdi-plus"
              class="pr-3"
            />
            <p style="white-space: normal;">
              {{ $translate(`${translationName}.add`) }}
            </p>
          </v-btn>
        </template>
        <v-card :title="$translate(`${translationName}.add`)">
          <v-card-text>
            <slot name="selection" />
          </v-card-text>
          <v-card-actions>
            <v-btn
              text="Annuler"
              @click="dialog = false; $emit('isOpen', false)"
            />
            <v-spacer />

            <slot name="validation" />
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <!-- BASIC REDIRECT ADD BUTTON -->
    <div v-else-if="!Object.keys(addOptions).length"> <!-- d-flex flex-row-reverse  -->
      <NuxtLink :to="`${defaultUrl}/nouveau/formulaire`">
        <v-btn
          color="primary"
          :style="$vuetify.display.width < 300 ? 'height: auto; padding: 10px' : ''"
        >
          <v-icon
            icon="mdi-plus"
            class="pr-2"
          />
          <p style="white-space: normal;">
            {{ $translate(`${translationName}.add`) }}
          </p>
        </v-btn>
      </NuxtLink>
    </div>

    <!-- REDIRECT ADD BUTTON WITH DROPDOWN & PARAMETERS IN CREATE URL -->
    <template v-else>
      <v-btn
        id="menu-add-options"
        color="primary"
      >
        <v-icon
          icon="mdi-plus"
          class="pr-3"
        />
        <p style="white-space: normal;">
          {{ $translate(`${translationName}.add`) }}
        </p>
      </v-btn>
      <v-menu activator="#menu-add-options">
        <v-list>
          <v-list-item
            v-for="(option, index) in addOptionsSetup"
            :key="index"
            :value="index"
          >
            <v-list-item-title>
              <NuxtLink
                :to="`${defaultUrl}/nouveau/formulaire?${option.parameters}`"
                class="menu-add-options-list-item"
              >
                <v-list-item-title>{{ option.translation }}</v-list-item-title>
              </NuxtLink>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </span>
</template>

<script lang="ts">
export default {
    name : "AddButton",
    props : {
        permissionName : { type : String, required : true },
        defaultUrl : { type : String, required : true },
        translationName : { type : String, required : true },
        addOptions : { type : Object, required : false, default: () => ({}) },
        setupDialog : { type : Boolean, required : false },
        disabledTooltip : { type : String, required : false, default : "" },
        width : { type : String, required : false, default : "" },
    },
    emits: ['isOpen'],
    data () {
        return {
            dialog : false,
        }
    },
    computed : {
        addOptionsSetup () {
            const options = []
            const keys = Object.keys(this.addOptions)
            keys.forEach( key => {
                this.addOptions[key].forEach( item => {
                    const option = {
                        translation : this.$translate(`${this.translationName}.${key}.${item}`),
                        parameters : `${key}=${item}`
                    }
                    options.push(option)
                })
            })
            return options
        }
    },
    methods : {
        closeModal () {
            this.dialog = !this.dialog
        }
    }
}
</script>
